import React from 'react';
import c from 'classnames';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import TierIcon from '@wix/da-ds/pkg/Icons/24x24/Tier';
import TierIconSmall from '@wix/da-ds/pkg/Icons/16x16/Tier';
import BrandedButton from '@wix/da-ds/pkg/Buttons/BrandedButton';
import SolidButton from '@wix/da-ds/pkg/Buttons/SolidButton';
import { useSubscribeButton } from '../useSubscribeButton';
import s from './Subscribe.scss';
const SubscribeVariant = ({ tier, withPrice = false, size = 'medium', className, href })=>{
    const newSubscribeButtons = useFlag('subscribe_btns');
    const { onClick, biData, text } = useSubscribeButton(tier, {
        type: 'subscribe',
        withPrice
    });
    const ButtonComponent = newSubscribeButtons ? SolidButton : BrandedButton;
    return /*#__PURE__*/ React.createElement(ButtonComponent, {
        isFakeButton: true,
        className: c(s['root'], className),
        icon: newSubscribeButtons ? size === 'small' ? TierIconSmall : TierIcon : undefined,
        size: size,
        variant: newSubscribeButtons ? 'main' : 'brand-green',
        href: href,
        onClick: onClick,
        biData: biData
    }, text);
};
SubscribeVariant.displayName = 'SubscribeVariant';
export default SubscribeVariant;
